import { Field, ErrorMessage } from 'formik';
import { useState } from 'react';
import PropTypes from 'prop-types';
import { _InputWrapper as InputWrapper } from './Input.style';
import { _Label as Label } from '../../Styled/Label';
import { _Error as Error } from '../../Styled/Error';
import { _FieldDescription as FieldDescription } from '../../Styled/FieldDescription';

export const Input = ({ id, props }) => {
  const { label, name, type, required, description, initialValue } = props;
  const [userInput, setUserInput] = useState(initialValue ? initialValue : '');
  

  const handleInputChange = (event) => {
    const input = event.target.value;

    if (name === 'phone') {
      if ((name === input.slice(0, 4)) === initialValue) {
        setUserInput(event.target.value);
      } else setUserInput(initialValue);
    } else {
      setUserInput(event.target.value);
    }

    props.handleChange(event);
  };

  return (
    <InputWrapper>
      <Label htmlFor={id}>
        {label} {required ? '*' : ''}
      </Label>
      {description ? <FieldDescription>{description}</FieldDescription> : ''}
      <Field
        id={id}
        name={name ? name : `form['${label}']`}
        type={type ? type : 'text'} // Use the specified input type
        required={required}
        maxLength={255}
        value={userInput}
        onChange={handleInputChange}
      />
      {name && <ErrorMessage component={Error} name={name} />}
    </InputWrapper>
  );
};

Input.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
  type: PropTypes.oneOf(['text', 'email', 'tel', 'date']), // Define supported types
  required: PropTypes.bool,
};
